class ArticleHeroMedia {
    constructor(root) {
        this.root = root;
        this.trigger = root.querySelector('[data-article-hero-play]');
        if (!this.trigger) {
            return;
        }

        this.videoId = root.dataset.videoId || '';
        this.videoUrl = root.dataset.videoUrl || '';
        this.isPlaying = false;
        this.handleClick = this.handleClick.bind(this);
        this.trigger.addEventListener('click', this.handleClick);
    }

    handleClick() {
        if (this.isPlaying) {
            return;
        }

        const embedUrl = this.buildEmbedUrl(this.videoId, this.videoUrl);
        if (!embedUrl) {
            return;
        }

        const iframe = document.createElement('iframe');
        iframe.className = 'absolute inset-0 w-full h-full border-0';
        iframe.setAttribute('allow', 'autoplay; fullscreen');
        iframe.setAttribute('allowfullscreen', 'true');
        iframe.setAttribute('title', 'Wideo z YouTube');
        iframe.src = embedUrl;

        this.root.innerHTML = '';
        this.root.appendChild(iframe);
        this.isPlaying = true;
    }

    buildEmbedUrl(id, url) {
        const videoId = id || this.extractYoutubeId(url);
        if (!videoId) return '';
        return `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;
    }

    extractYoutubeId(url) {
        if (!url) return '';
        try {
            const parsed = new URL(url);
            const host = parsed.hostname || '';
            if (host.includes('youtu.be')) {
                return parsed.pathname.replace('/', '');
            }
            if (host.includes('youtube.com') || host.includes('youtube-nocookie.com')) {
                const videoId = parsed.searchParams.get('v');
                if (videoId) return videoId;
                if (parsed.pathname.startsWith('/embed/')) {
                    return parsed.pathname.replace('/embed/', '');
                }
                if (parsed.pathname.startsWith('/shorts/')) {
                    return parsed.pathname.replace('/shorts/', '');
                }
            }
        } catch (e) {
            return '';
        }
        return '';
    }
}

const initArticleHeroMedia = () => {
    document
        .querySelectorAll('[data-article-hero-media]')
        .forEach(section => new ArticleHeroMedia(section));
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initArticleHeroMedia);
} else {
    initArticleHeroMedia();
}
